import { ErrorModal } from "@dexteel/mesf-core";
import { CircularProgress, TextField } from "@mui/material";
import { Autocomplete } from "@mui/material";
import { get } from "lodash-es";
import { useEffect, useState } from "react";
import type { FieldError } from "react-hook-form";
import type { MoldSize } from "../model/MoldSize";
import { getMoldSizes } from "../repositories/MoldSizeRepository";

type Props = {
  label: string;
  value: number | null;
  onChange?: Function;
  fieldError: FieldError | undefined;
  disabled?: boolean;
};

export const MoldSizeAutocomplete = ({
  label,
  value,
  onChange = () => {},
  fieldError,
  disabled = false,
}: Props) => {
  const [moldSizes, setMoldSizes] = useState<MoldSize[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState("");

  const loadData = async () => {
    setIsLoading(true);
    setError("");
    const resp = await getMoldSizes();
    if (resp.ok) {
      const rows = get(resp, "data.tables[0].rows", []) as MoldSize[];
      setMoldSizes(rows);
    } else {
      setError(resp.message);
    }
    setIsLoading(false);
  };

  const selectedValue =
    moldSizes?.find((ms: MoldSize) => ms.MoldSizeId === value) || null;

  useEffect(() => {
    loadData().then(() => {});
    return;
  }, []);

  return (
    <>
      <Autocomplete
        id="clear-on-escape"
        clearOnEscape
        options={moldSizes ?? []}
        getOptionLabel={(option) => option.MoldSizeName}
        onChange={(event, newValue) => {
          onChange(newValue ? newValue.MoldSizeId : null);
        }}
        renderInput={(params) => (
          <>
            <TextField
              {...params}
              label={label}
              variant="outlined"
              size="small"
              fullWidth
              margin="dense"
              error={!!fieldError}
              helperText={fieldError?.message}
              slotProps={{
                input: {
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {isLoading ? (
                        <CircularProgress color="inherit" size={20} />
                      ) : (
                        params.InputProps.endAdornment
                      )}
                    </>
                  ),
                },
              }}
            />
          </>
        )}
        disabled={disabled}
        value={selectedValue}
      />
      <ErrorModal error={error} onHide={() => setError("")} />
    </>
  );
};
